import { ResidentModel } from "../../../services/api/types/residents/models/ResidentModel";
import { SingleHandoverAppointmentModel } from "../../../services/api/types/shiftHandover/models/SingleHandoverAppointmentModel";
import { Text } from "react-native";
import { format } from "date-fns";
import { TaskItem } from "./TaskItem";

export interface Props {
  residents: ResidentModel[];
  appointment: SingleHandoverAppointmentModel;
  onRowPress: (
    residentId: number | undefined,
    appointment: SingleHandoverAppointmentModel,
  ) => void;
  handleMarkAsDone: (appointment) => void;
  isUpcomingCompleted: boolean | undefined;
  allResidents: boolean;
}

export function UpcomingTaskItem({
  residents,
  appointment,
  onRowPress,
  handleMarkAsDone,
  isUpcomingCompleted,
  allResidents,
}: Props) {
  const preparationNeeded = !!appointment.preparation_needed;
  return (
    <TaskItem
      residents={residents}
      onRowPress={() => {
        const residentId =
          residents?.length === 1 ? residents[0]?.id : undefined;
        onRowPress(residentId, appointment);
      }}
      backgroundColourClass="bg-info-25"
      isCompleted={isUpcomingCompleted}
      handleMarkAsDone={() => handleMarkAsDone(appointment)}
      renderContent={() => (
        <Text className="text-base">
          {`${appointment?.title} (${appointment?.starts_at ? format(appointment?.starts_at, "dd-MM-yyyy HH:mm") : ""})`}
        </Text>
      )}
      allResidents={allResidents}
      preparationNeeded={preparationNeeded}
    />
  );
}
